<template>
    <div class="app-container">
        <!-- 顶部导航 -->
        <header class="header">
            <div class="logo">
                <img class="logo-icon" :src="logoIcon" alt="">
                <span class="logo-text">慧钢琴</span>
            </div>
            <div class="login-btn" @click="goToLogin">学生登录</div>
        </header>

        <!-- 主视觉区域 -->
        <section class="hero">
            <div class="hero-inner">
                <div class="hero-text">
                    <h1 class="hero-title">天琴湾钢琴艺术中心</h1>
                    <p class="hero-subtitle">
                        用稳定的课程节奏和清晰的反馈，陪孩子一起走钢琴这条路。
                    </p>
                </div>
            </div>
        </section>

        <!-- 特色优势 -->
        <section class="features">
            <h2 class="section-title">教学特色</h2>
            <div class="feature-list">
                <div class="feature-item">
                    <h3 class="feature-title">一对一授课</h3>
                    <p class="feature-desc">根据孩子基础和性格，安排合适的节奏。</p>
                </div>
                <div class="feature-item">
                    <h3 class="feature-title">课堂记录</h3>
                    <p class="feature-desc">每节课有老师记录和作业提醒，方便家长查看。</p>
                </div>
                <div class="feature-item">
                    <h3 class="feature-title">舞台与考级</h3>
                    <p class="feature-desc">兼顾考级准备和小型演出，积累自信。</p>
                </div>
            </div>
        </section>

        <!-- 课程方向 -->
        <section class="courses">
            <h2 class="section-title">课程方向</h2>
            <div class="course-list">
                <div class="course-item">
                    <h3 class="course-title">基础启蒙</h3>
                    <p class="course-desc">零基础儿童，从兴趣和基本习惯开始。</p>
                </div>
                <div class="course-item">
                    <h3 class="course-title">系统进阶</h3>
                    <p class="course-desc">逐步打牢指法、音阶和曲目演奏能力。</p>
                </div>
                <div class="course-item">
                    <h3 class="course-title">兴趣与表演</h3>
                    <p class="course-desc">以曲目为主，适合希望多弹喜欢的曲子。</p>
                </div>
            </div>
        </section>

        <!-- 教学流程 -->
        <section class="flow">
            <h2 class="section-title">教学流程</h2>
            <div class="flow-list">
                <div class="flow-step">
                    <div class="flow-circle">1</div>
                    <div class="flow-content">
                        <h3 class="flow-title">沟通与了解</h3>
                        <p class="flow-desc">先了解孩子基础和目标，再安排课程。</p>
                    </div>
                </div>
                <div class="flow-step">
                    <div class="flow-circle">2</div>
                    <div class="flow-content">
                        <h3 class="flow-title">课堂授课</h3>
                        <p class="flow-desc">课堂以技巧练习和曲目为主，循序渐进。</p>
                    </div>
                </div>
                <div class="flow-step">
                    <div class="flow-circle">3</div>
                    <div class="flow-content">
                        <h3 class="flow-title">课后反馈</h3>
                        <p class="flow-desc">老师记录课堂情况，学生可登录查看。</p>
                    </div>
                </div>
                <div class="flow-step">
                    <div class="flow-circle">4</div>
                    <div class="flow-content">
                        <h3 class="flow-title">阶段评估</h3>
                        <p class="flow-desc">结合实际情况考虑考级或小型演出。</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 家长须知 -->
        <section class="notice">
            <h2 class="section-title">家长须知</h2>
            <div class="notice-card">
                <p class="notice-text">
                    学生登录使用报名时登记的姓名和手机号，如无法登录请联系老师协助。
                </p>
                <p class="notice-text">
                    建议每周按时上课并保持练琴节奏，有任何安排变动尽量提前沟通。
                </p>
            </div>
        </section>

        <!-- 底部联系 -->
        <footer class="footer">
            <div class="contact-info">
                <p>地址：合肥市习友路天琴湾小区6栋404室</p>
                <p>电话：159-5695-6678</p>
                <p>时间：9:00-20:00</p>
            </div>
            <div class="copyright">
                © {{ currentYear }} 天琴湾钢琴艺术中心 版权所有
            </div>
        </footer>
    </div>
</template>

<script>
import logoIcon from "@/assets/logo.png";

export default {
    data() {
        return {
            logoIcon,
            currentYear: new Date().getFullYear()
        };
    },
    methods: {
        goToLogin() {
            this.$router.push("/login");
        }
    }
};
</script>

<style scoped>
.app-container {
    max-width: 100%;
    overflow-x: hidden;
    min-height: 100vh;
    color: #111827;
    background:
        radial-gradient(circle at 0 0, #e6edff 0, transparent 45%),
        radial-gradient(circle at 100% 0, #fef3c7 0, transparent 45%),
        linear-gradient(to bottom, #f4f5fb 0, #f9fafb 100%);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif;
}

/* 顶部导航 */
.header {
    position: sticky;
    top: 0;
    z-index: 20;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    background: linear-gradient(to bottom,
            rgba(244, 245, 251, 0.96),
            rgba(244, 245, 251, 0.92),
            transparent);
    backdrop-filter: blur(12px);
    box-sizing: border-box;
}

.logo {
    display: flex;
    align-items: center;
}

.logo-icon {
    width: 28px;
    height: 28px;
    margin-right: 8px;
    display: block;
}

.logo-text {
    font-size: 20px;
    font-weight: 600;
    color: #111827;
}

/* 学生登录按钮 */
.login-btn {
    padding: 6px 14px;
    border-radius: 999px;
    font-size: 13px;
    color: #1d4ed8;
    border: 1px solid rgba(129, 140, 248, 0.7);
    background: rgba(255, 255, 255, 0.9);
    cursor: pointer;
    box-shadow: 0 3px 10px rgba(148, 163, 184, 0.3);
}

/* 主视觉区域 */
.hero {
    padding: 40px 20px 32px;
    box-sizing: border-box;
}

.hero-inner {
    max-width: 900px;
    margin: 0 auto;
    padding: 26px 20px 30px;
    border-radius: 18px;
    background: linear-gradient(135deg, #eff6ff 0, #e0f2fe 50%, #fef9c3 100%);
    box-shadow:
        0 18px 40px rgba(148, 163, 184, 0.4),
        0 0 0 1px rgba(191, 219, 254, 0.9);
    text-align: left;
}

.hero-text {
    max-width: 600px;
}

.hero-title {
    font-size: 24px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 10px;
}

.hero-subtitle {
    font-size: 14px;
    line-height: 1.7;
    color: #4b5563;
    margin: 0;
}

/* 公共 section 标题 */
.section-title {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 20px;
    position: relative;
}

.section-title::after {
    content: "";
    display: block;
    width: 72px;
    height: 3px;
    border-radius: 999px;
    background: linear-gradient(to right, #2563eb, #f59e0b);
    margin: 8px auto 0;
}

/* 特色优势 */
.features {
    padding: 28px 20px;
    box-sizing: border-box;
}

.feature-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 900px;
    margin: 0 auto;
}

.feature-item {
    padding: 12px 14px;
    border-radius: 14px;
    background: #ffffff;
    box-shadow:
        0 10px 24px rgba(148, 163, 184, 0.25),
        0 0 0 1px rgba(226, 232, 240, 0.9);
    text-align: left;
}

.feature-title {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 4px;
}

.feature-desc {
    font-size: 13px;
    line-height: 1.6;
    color: #4b5563;
    margin: 0;
}

/* 课程介绍 */
.courses {
    padding: 28px 20px 34px;
    box-sizing: border-box;
}

.course-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 900px;
    margin: 0 auto;
}

.course-item {
    padding: 14px 14px;
    border-radius: 14px;
    background: #ffffff;
    box-shadow:
        0 10px 24px rgba(148, 163, 184, 0.25),
        0 0 0 1px rgba(226, 232, 240, 0.9);
    border-left: 4px solid #2563eb;
}

.course-item:nth-child(2) {
    border-left-color: #f59e0b;
}

.course-item:nth-child(3) {
    border-left-color: #10b981;
}

.course-title {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 4px;
}

.course-desc {
    font-size: 13px;
    color: #4b5563;
    margin: 0;
}

/* 教学流程 */
.flow {
    padding: 24px 20px 34px;
    box-sizing: border-box;
}

.flow-list {
    max-width: 900px;
    margin: 0 auto;
    border-radius: 16px;
    background: #ffffff;
    box-shadow:
        0 10px 24px rgba(148, 163, 184, 0.25),
        0 0 0 1px rgba(226, 232, 240, 0.9);
    padding: 10px 14px;
    box-sizing: border-box;
}

/* 每一行：左数字 + 右文字，整体左对齐 */
.flow-step {
    display: flex;
    align-items: flex-start;
    padding: 6px 0;
}

/* 左边数字圆点 */
.flow-circle {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border-radius: 999px;
    background: #2563eb;
    color: #ffffff;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
}

/* 右边文字区域 */
.flow-content {
    flex: 1;
    text-align: left;
}

.flow-title {
    margin: 0 0 2px;
    font-size: 14px;
    font-weight: 600;
    color: #111827;
}

.flow-desc {
    margin: 0;
    font-size: 13px;
    line-height: 1.6;
    color: #4b5563;
}


/* 家长须知 */
.notice {
    padding: 0 20px 34px;
    box-sizing: border-box;
}

.notice-card {
    max-width: 900px;
    margin: 0 auto;
    border-radius: 16px;
    background: #ffffff;
    box-shadow:
        0 10px 24px rgba(148, 163, 184, 0.25),
        0 0 0 1px rgba(226, 232, 240, 0.9);
    padding: 12px 14px;
    box-sizing: border-box;
}

.notice-text {
    margin: 4px 0;
    font-size: 13px;
    line-height: 1.7;
    color: #4b5563;
}

/* 底部 */
.footer {
    background: linear-gradient(135deg, #111827 0%, #020617 100%);
    color: white;
    padding: 24px 16px 18px;
    text-align: center;
    box-sizing: border-box;
}

.contact-info {
    margin-bottom: 18px;
    line-height: 1.8;
}

.contact-info p {
    opacity: 0.9;
    font-size: 13px;
    margin: 0;
}

.copyright {
    font-size: 12px;
    opacity: 0.7;
    padding-top: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.18);
}

/* 响应式调整 */
@media (min-width: 768px) {
    .hero {
        padding: 50px 24px 36px;
    }

    .hero-title {
        font-size: 26px;
    }

    .hero-subtitle {
        font-size: 15px;
    }

    .feature-list {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .feature-item {
        flex: 1;
        min-width: 240px;
        max-width: 280px;
    }

    .course-list {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .course-item {
        flex: 1;
        min-width: 240px;
        max-width: 300px;
    }
}
</style>
